// Quiz parentaux — 22 auto-évaluations bienveillantes, sans jugement.
// Chaque question a 3 options notées 1 / 2 / 4. Les paliers de feedback couvrent
// n..2n (à réajuster), 2n+1..3n (en bonne voie), 3n+1..4n (posture solide).

export const QUIZ_CATEGORIES = [
  "Émotions",
  "Écrans",
  "Sommeil",
  "Autonomie",
  "Fratrie",
  "École",
  "Communication",
  "Alimentation",
  "Moi parent",
  "Ados",
];

export const QUIZZES = [
  {
    id: "q1",
    title: "Quel est ton style face aux crises ?",
    description: "5 questions pour découvrir ta posture parentale dominante.",
    category: "Émotions",
    ages: "Tous âges",
    questions: [
      { q: "Ton enfant hurle au supermarché car tu refuses un bonbon. Tu :", options: [
        { text: "Céder pour éviter le regard des autres", score: 1 },
        { text: "Élever la voix pour qu'il se taise", score: 2 },
        { text: "S'accroupir, nommer l'émotion et attendre", score: 4 },
      ]},
      { q: "Après une crise, tu :", options: [
        { text: "Passe à autre chose sans en reparler", score: 2 },
        { text: "Le puni pour lui apprendre", score: 1 },
        { text: "Reformule calmement ce qu'il a ressenti", score: 4 },
      ]},
      { q: "Face à un « NON » ferme :", options: [
        { text: "Tu insistes et hausses le ton", score: 1 },
        { text: "Tu proposes une alternative", score: 4 },
        { text: "Tu abandonnes la demande", score: 2 },
      ]},
      { q: "Ton propre stress avant une crise :", options: [
        { text: "Je m'énerve d'abord, je réfléchis après", score: 1 },
        { text: "Je respire, je me pose une question", score: 4 },
        { text: "Je fais semblant que tout va bien", score: 2 },
      ]},
      { q: "Après une journée difficile :", options: [
        { text: "Tu culpabilises longtemps", score: 2 },
        { text: "Tu en parles à ton co-parent ou un ami", score: 4 },
        { text: "Tu évites d'y penser", score: 1 },
      ]},
    ],
    feedback: [
      { min: 5, max: 10, title: "Parent en apprentissage", text: "Les réactions à chaud sont naturelles ! Commence par respirer avant de répondre. Chaque crise gérée sereinement construit un pas." },
      { min: 11, max: 15, title: "Parent équilibré", text: "Tu as déjà de belles bases. Continue à nommer les émotions et à te faire confiance." },
      { min: 16, max: 20, title: "Parent connecté", text: "Bravo ! Ta posture d'écoute active est un cadeau. N'oublie pas de prendre soin de toi aussi." },
    ],
  },
  {
    id: "q2",
    title: "Gestion du temps d'écran",
    description: "4 questions pour évaluer ta stratégie écrans.",
    category: "Écrans",
    ages: "Dès 2 ans",
    questions: [
      { q: "Les repas se prennent :", options: [
        { text: "Avec la télé ou tablette", score: 1 },
        { text: "Sans écran, tous ensemble", score: 4 },
        { text: "Parfois avec, parfois sans", score: 2 },
      ]},
      { q: "Le soir avant de dormir :", options: [
        { text: "1h sans écran systématique", score: 4 },
        { text: "Écran jusqu'au coucher", score: 1 },
        { text: "Ça dépend des jours", score: 2 },
      ]},
      { q: "Le contenu regardé :", options: [
        { text: "Choisi ensemble, adapté à l'âge", score: 4 },
        { text: "L'enfant choisit librement", score: 1 },
        { text: "Je vérifie de temps en temps", score: 2 },
      ]},
      { q: "Quand tu es fatigué(e) :", options: [
        { text: "L'écran devient ma nounou", score: 1 },
        { text: "Je propose un livre ou dessin", score: 4 },
        { text: "Je négocie 30 min max", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "À réajuster", text: "Petits pas : commence par instaurer LES REPAS sans écran cette semaine. C'est le levier le plus puissant." },
      { min: 9, max: 12, title: "En bonne voie", text: "Tu as conscience des enjeux. Fixe des créneaux clairs et affiche-les au frigo." },
      { min: 13, max: 16, title: "Stratégie solide", text: "Excellent ! Ton cadre est cohérent. Pense à réévaluer tous les 6 mois selon l'âge." },
    ],
  },
  {
    id: "q3",
    title: "Le coucher chez toi, c'est comment ?",
    description: "4 questions sur ton rituel du soir.",
    category: "Sommeil",
    ages: "Dès 1 an",
    questions: [
      { q: "L'heure du coucher en semaine :", options: [
        { text: "Toujours à peu près la même", score: 4 },
        { text: "Très variable selon la soirée", score: 1 },
        { text: "Stable, sauf imprévus", score: 2 },
      ]},
      { q: "Le rituel avant de dormir :", options: [
        { text: "Toujours la même séquence", score: 4 },
        { text: "Il n'y en a pas vraiment", score: 1 },
        { text: "Ça dépend de qui couche l'enfant", score: 2 },
      ]},
      { q: "Quand il réclame « encore une histoire » :", options: [
        { text: "J'annonce d'avance combien il y en aura", score: 4 },
        { text: "Je cède, puis je m'agace", score: 1 },
        { text: "Je refuse net et je sors", score: 2 },
      ]},
      { q: "S'il se relève trois fois :", options: [
        { text: "Je le raccompagne sans discuter, calmement", score: 4 },
        { text: "Je finis par crier", score: 1 },
        { text: "Je le laisse venir dans le salon", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Le soir est encore flou", text: "Choisis trois étapes toujours dans le même ordre (bain, histoire, câlin). Le corps anticipe le sommeil grâce à la répétition." },
      { min: 9, max: 12, title: "Un cadre qui se construit", text: "Ton rituel existe, il lui manque de la constance. Écris-le et affiche-le : les enfants adorent savoir ce qui vient." },
      { min: 13, max: 16, title: "Des soirées apaisées", text: "Ton cadre est clair et rassurant. Continue, et garde-le lors des vacances : c'est là qu'il se perd." },
    ],
  },
  {
    id: "q4",
    title: "Autonomie : tu fais à sa place ?",
    description: "4 questions pour mesurer la place que tu laisses à ton enfant.",
    category: "Autonomie",
    ages: "Dès 3 ans",
    questions: [
      { q: "S'habiller le matin :", options: [
        { text: "Je l'habille, c'est plus rapide", score: 1 },
        { text: "Il essaie seul, je viens si besoin", score: 4 },
        { text: "Il commence, je finis toujours", score: 2 },
      ]},
      { q: "Quand il renverse son verre :", options: [
        { text: "Je nettoie en soupirant", score: 1 },
        { text: "Je lui donne un torchon", score: 4 },
        { text: "Je nettoie et j'explique", score: 2 },
      ]},
      { q: "Les tâches à la maison :", options: [
        { text: "Il a une vraie responsabilité régulière", score: 4 },
        { text: "Il aide quand j'y pense", score: 2 },
        { text: "Il n'en a pas encore", score: 1 },
      ]},
      { q: "Quand il n'arrive pas à faire un truc :", options: [
        { text: "Je le fais pour lui", score: 1 },
        { text: "Je décris l'étape suivante sans faire", score: 4 },
        { text: "Je l'encourage puis je le fais", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Tu portes beaucoup", text: "Faire à sa place rassure sur le moment mais fatigue à long terme. Choisis UNE tâche à lui confier cette semaine." },
      { min: 9, max: 12, title: "Sur le bon chemin", text: "Tu lui laisses de la place. Prochain pas : accepter que ce soit moins bien fait, sans repasser derrière." },
      { min: 13, max: 16, title: "Tu construis un enfant capable", text: "Bravo, tu supportes la lenteur et l'imperfection — c'est exactement ce qui rend autonome." },
    ],
  },
  {
    id: "q5",
    title: "Disputes de fratrie : ton réflexe",
    description: "4 questions sur ta façon d'arbitrer.",
    category: "Fratrie",
    ages: "Dès 3 ans",
    questions: [
      { q: "Ils se disputent un jouet :", options: [
        { text: "Je désigne un gagnant", score: 1 },
        { text: "Je décris la situation et je les laisse chercher", score: 4 },
        { text: "Je confisque le jouet", score: 2 },
      ]},
      { q: "L'un dit « c'est toujours lui que tu préfères » :", options: [
        { text: "Je nie en bloc", score: 2 },
        { text: "J'accueille sa jalousie sans la corriger", score: 4 },
        { text: "Je m'agace de l'injustice du reproche", score: 1 },
      ]},
      { q: "Les comparaisons entre eux :", options: [
        { text: "J'évite totalement de comparer", score: 4 },
        { text: "J'en fais parfois pour motiver", score: 2 },
        { text: "Je cite souvent l'exemple de l'autre", score: 1 },
      ]},
      { q: "Temps en tête-à-tête avec chacun :", options: [
        { text: "Un moment régulier pour chacun", score: 4 },
        { text: "Rarement, tout est collectif", score: 1 },
        { text: "De temps en temps", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "L'arbitre fatigué", text: "Trancher à leur place les met en rivalité. Décris ce que tu vois (« deux enfants, un seul camion ») et laisse-les proposer." },
      { min: 9, max: 12, title: "Médiateur en devenir", text: "Tu cherches l'équité. Ajoute du temps individuel : la jalousie baisse quand chacun a « son » moment." },
      { min: 13, max: 16, title: "Tu soignes le lien", text: "Tu n'entres pas dans le jeu de la comparaison, et c'est précieux. Continue à nommer les émotions sans les juger." },
    ],
  },
  {
    id: "q6",
    title: "Devoirs : la guerre ou la paix ?",
    description: "4 questions sur les devoirs à la maison.",
    category: "École",
    ages: "Dès 6 ans",
    questions: [
      { q: "Le moment des devoirs :", options: [
        { text: "Toujours le même créneau", score: 4 },
        { text: "Quand on y pense, souvent tard", score: 1 },
        { text: "Variable selon les activités", score: 2 },
      ]},
      { q: "Quand il bloque :", options: [
        { text: "Je donne la réponse pour avancer", score: 1 },
        { text: "Je pose une question qui l'aide à chercher", score: 4 },
        { text: "Je lui explique tout longuement", score: 2 },
      ]},
      { q: "Face à une mauvaise note :", options: [
        { text: "Je parle de l'effort et de la suite", score: 4 },
        { text: "Je sanctionne", score: 1 },
        { text: "Je dédramatise sans en reparler", score: 2 },
      ]},
      { q: "Pendant les devoirs, moi je suis :", options: [
        { text: "À côté, disponible mais occupé(e)", score: 4 },
        { text: "Penché(e) sur son épaule en permanence", score: 2 },
        { text: "Dans une autre pièce, sur mon téléphone", score: 1 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Ça coince encore", text: "Un créneau fixe et court (20 min max en primaire) change tout. Et rappelle-toi : tu n'es pas son professeur, tu es son abri." },
      { min: 9, max: 12, title: "Un cadre qui tient", text: "Tu accompagnes sans tout porter. Essaie de remplacer les explications par des questions : « par quoi tu commences ? »" },
      { min: 13, max: 16, title: "Devoirs sereins", text: "Tu sépares la valeur de ton enfant de ses résultats. C'est le meilleur cadeau scolaire possible." },
    ],
  },
  {
    id: "q7",
    title: "Tu parles comment quand c'est tendu ?",
    description: "5 questions sur ta communication sous pression.",
    category: "Communication",
    ages: "Tous âges",
    questions: [
      { q: "Quand tu demandes quelque chose :", options: [
        { text: "Je dis ce que je veux, précisément", score: 4 },
        { text: "Je dis surtout ce que je ne veux pas", score: 2 },
        { text: "Je répète dix fois puis je crie", score: 1 },
      ]},
      { q: "Tes phrases commencent souvent par :", options: [
        { text: "« Tu ne… », « Tu es… »", score: 1 },
        { text: "« J'ai besoin de… », « Je vois que… »", score: 4 },
        { text: "« Il faut que… »", score: 2 },
      ]},
      { q: "Quand il te coupe la parole :", options: [
        { text: "Je l'écoute puis je reprends", score: 4 },
        { text: "Je monte le ton pour finir", score: 1 },
        { text: "J'abandonne ma phrase", score: 2 },
      ]},
      { q: "Après avoir crié :", options: [
        { text: "Je reviens et je m'excuse", score: 4 },
        { text: "Je fais comme si rien n'était", score: 1 },
        { text: "Je justifie mon énervement", score: 2 },
      ]},
      { q: "Les consignes du matin :", options: [
        { text: "Une seule à la fois", score: 4 },
        { text: "Trois ou quatre d'un coup", score: 1 },
        { text: "Deux, en général", score: 2 },
      ]},
    ],
    feedback: [
      { min: 5, max: 10, title: "Les mots partent vite", text: "Essaie une seule consigne courte, formulée en positif. Et la réparation après un cri compte plus que le cri lui-même." },
      { min: 11, max: 15, title: "Tu te reprends bien", text: "Tu sais revenir vers ton enfant. Passe encore plus de « tu » au « je » : ça désarme les conflits." },
      { min: 16, max: 20, title: "Parole qui apaise", text: "Ta communication est claire et respectueuse. Ton enfant apprend à parler comme tu lui parles." },
    ],
  },
  {
    id: "q8",
    title: "Les repas, c'est un combat ?",
    description: "4 questions sur l'alimentation à table.",
    category: "Alimentation",
    ages: "Dès 2 ans",
    questions: [
      { q: "S'il refuse un aliment :", options: [
        { text: "Je l'oblige à finir", score: 1 },
        { text: "Je le repropose plus tard sans forcer", score: 4 },
        { text: "Je remplace par ce qu'il aime", score: 2 },
      ]},
      { q: "Les quantités :", options: [
        { text: "C'est lui qui sait quand il a assez mangé", score: 4 },
        { text: "Je décide de l'assiette finie", score: 1 },
        { text: "Je négocie « encore trois bouchées »", score: 2 },
      ]},
      { q: "Le dessert :", options: [
        { text: "Sert de récompense ou de menace", score: 1 },
        { text: "Fait simplement partie du repas", score: 4 },
        { text: "Dépend de ce qu'il a mangé avant", score: 2 },
      ]},
      { q: "Il participe à la préparation :", options: [
        { text: "Souvent, il touche et goûte", score: 4 },
        { text: "Jamais, c'est plus simple", score: 1 },
        { text: "Le week-end parfois", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Trop d'enjeux à table", text: "Plus on force, plus on bloque. Ton rôle : proposer. Le sien : décider combien. Reproposer sans pression finit par marcher." },
      { min: 9, max: 12, title: "Ça se détend", text: "Tu lâches du lest. Sors le dessert du système de récompense : il perdra son statut de trophée." },
      { min: 13, max: 16, title: "Repas apaisés", text: "Tu respectes ses signaux de faim et tu l'impliques : c'est exactement ce qui construit un bon rapport à la nourriture." },
    ],
  },
  {
    id: "q9",
    title: "Et toi, tu te reposes quand ?",
    description: "4 questions sur ta charge mentale.",
    category: "Moi parent",
    ages: "Tous âges",
    questions: [
      { q: "Un moment pour toi dans la semaine :", options: [
        { text: "Oui, prévu et tenu", score: 4 },
        { text: "Jamais", score: 1 },
        { text: "Quand il reste du temps", score: 2 },
      ]},
      { q: "Demander de l'aide :", options: [
        { text: "Je sais le faire", score: 4 },
        { text: "Je préfère tout gérer", score: 1 },
        { text: "Seulement en cas d'urgence", score: 2 },
      ]},
      { q: "Ton sommeil :", options: [
        { text: "Correct la plupart des nuits", score: 4 },
        { text: "Je grignote toujours mes nuits", score: 1 },
        { text: "Variable", score: 2 },
      ]},
      { q: "La culpabilité :", options: [
        { text: "Elle revient chaque soir", score: 1 },
        { text: "Je la reconnais et je passe", score: 4 },
        { text: "Elle vient par vagues", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Le réservoir est bas", text: "Tu ne peux pas apaiser un enfant avec un réservoir vide. Bloque 30 minutes pour toi cette semaine, comme un rendez-vous." },
      { min: 9, max: 12, title: "Tu tiens, mais juste", text: "Tu commences à te préserver. Demande de l'aide AVANT d'être à bout, pas après." },
      { min: 13, max: 16, title: "Tu prends soin de toi", text: "Ton équilibre profite à toute la famille. Continue, et surveille les périodes de surcharge." },
    ],
  },
  {
    id: "q10",
    title: "Les limites : fermes ou floues ?",
    description: "4 questions sur ton cadre éducatif.",
    category: "Émotions",
    ages: "Dès 2 ans",
    questions: [
      { q: "Tes règles à la maison :", options: [
        { text: "Peu nombreuses et toujours tenues", score: 4 },
        { text: "Nombreuses mais rarement tenues", score: 1 },
        { text: "Elles changent selon ma fatigue", score: 2 },
      ]},
      { q: "Quand il teste une limite :", options: [
        { text: "Je répète la règle calmement, sans débat", score: 4 },
        { text: "Je négocie pour avoir la paix", score: 2 },
        { text: "Je menace de conséquences énormes", score: 1 },
      ]},
      { q: "Avec l'autre parent :", options: [
        { text: "On est d'accord sur l'essentiel", score: 4 },
        { text: "On se contredit souvent devant lui", score: 1 },
        { text: "On en parle après coup", score: 2 },
      ]},
      { q: "Les conséquences annoncées :", options: [
        { text: "Toujours appliquées", score: 4 },
        { text: "Souvent oubliées", score: 1 },
        { text: "Appliquées si j'ai l'énergie", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Un cadre à resserrer", text: "Moins de règles, mieux tenues : garde-en trois maximum et applique-les toujours. La constance rassure plus que la sévérité." },
      { min: 9, max: 12, title: "Un cadre en construction", text: "Tu es sur la bonne voie. Accorde-toi avec l'autre parent à l'avance, jamais devant l'enfant." },
      { min: 13, max: 16, title: "Un cadre sécurisant", text: "Tes limites sont claires et prévisibles : ton enfant sait à quoi s'attendre, et c'est ce qui l'apaise." },
    ],
  },
  {
    id: "q11",
    title: "Tu écoutes vraiment ?",
    description: "4 questions sur ta qualité d'écoute.",
    category: "Communication",
    ages: "Dès 3 ans",
    questions: [
      { q: "Quand il te raconte sa journée :", options: [
        { text: "Je m'arrête et je le regarde", score: 4 },
        { text: "J'écoute en faisant autre chose", score: 2 },
        { text: "Je réponds « mm-hmm » sans écouter", score: 1 },
      ]},
      { q: "Quand il est triste :", options: [
        { text: "Je dis « ce n'est pas grave »", score: 1 },
        { text: "Je nomme ce qu'il ressent", score: 4 },
        { text: "Je cherche tout de suite une solution", score: 2 },
      ]},
      { q: "Tes questions du soir :", options: [
        { text: "« Ça a été ? »", score: 2 },
        { text: "Une question précise et ouverte", score: 4 },
        { text: "Je ne pose pas de question", score: 1 },
      ]},
      { q: "Ton téléphone pendant qu'il parle :", options: [
        { text: "Posé, écran vers le bas", score: 4 },
        { text: "Dans la main", score: 1 },
        { text: "À côté, je jette un œil", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "L'écoute est distraite", text: "Deux minutes de vraie attention valent mieux qu'une heure à moitié. Pose le téléphone et regarde-le : il le sentira immédiatement." },
      { min: 9, max: 12, title: "Tu es disponible", text: "Tu écoutes souvent. Prochain pas : accueillir l'émotion avant de proposer une solution." },
      { min: 13, max: 16, title: "Écoute de qualité", text: "Ton enfant sait qu'il peut tout te dire. C'est la base de la confiance pour l'adolescence." },
    ],
  },
  {
    id: "q12",
    title: "Les matins chez toi",
    description: "4 questions sur la course du matin.",
    category: "Autonomie",
    ages: "Dès 3 ans",
    questions: [
      { q: "Le matin commence :", options: [
        { text: "Dans le calme, tout est préparé la veille", score: 4 },
        { text: "Dans la panique", score: 1 },
        { text: "Ça dépend des jours", score: 2 },
      ]},
      { q: "Les vêtements :", options: [
        { text: "Choisis la veille", score: 4 },
        { text: "Négociés sur place chaque matin", score: 1 },
        { text: "Parfois préparés", score: 2 },
      ]},
      { q: "Pour le presser :", options: [
        { text: "J'utilise un minuteur ou une chanson", score: 4 },
        { text: "Je répète et je m'énerve", score: 1 },
        { text: "Je fais à sa place", score: 2 },
      ]},
      { q: "Le petit-déjeuner :", options: [
        { text: "Assis, ensemble, sans écran", score: 4 },
        { text: "Debout, en vitesse", score: 1 },
        { text: "Devant un écran", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Matins sous tension", text: "Tout ce qui peut être fait la veille doit être fait la veille. Un minuteur visuel remplace mille rappels." },
      { min: 9, max: 12, title: "Ça s'organise", text: "Tu as déjà des repères. Ajoute une routine affichée en images : l'enfant s'y réfère sans toi." },
      { min: 13, max: 16, title: "Départs sereins", text: "Ton organisation protège l'humeur de toute la journée. Beau travail." },
    ],
  },
  {
    id: "q13",
    title: "Écrans : et toi, ton exemple ?",
    description: "4 questions sur TON usage devant lui.",
    category: "Écrans",
    ages: "Tous âges",
    questions: [
      { q: "Ton téléphone pendant les repas :", options: [
        { text: "Rangé, hors de la pièce", score: 4 },
        { text: "Sur la table", score: 1 },
        { text: "À portée, je le consulte", score: 2 },
      ]},
      { q: "Quand il te parle et que tu scrolles :", options: [
        { text: "Je lève les yeux et je range", score: 4 },
        { text: "Je continue en écoutant", score: 1 },
        { text: "Je dis « deux secondes »", score: 2 },
      ]},
      { q: "Le premier geste au réveil :", options: [
        { text: "Autre chose que le téléphone", score: 4 },
        { text: "Le téléphone", score: 1 },
        { text: "Ça dépend", score: 2 },
      ]},
      { q: "Tu parles de ton temps d'écran avec lui :", options: [
        { text: "Oui, honnêtement", score: 4 },
        { text: "Jamais", score: 1 },
        { text: "Seulement pour justifier le travail", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "L'exemple est brouillé", text: "Les enfants copient ce qu'on fait, pas ce qu'on dit. Un seul changement — téléphone hors de la table — vaut tous les discours." },
      { min: 9, max: 12, title: "Tu en as conscience", text: "Tu fais des efforts visibles. Annonce-les à voix haute : « je range mon téléphone pour t'écouter »." },
      { min: 13, max: 16, title: "Exemple cohérent", text: "Ton usage est maîtrisé et assumé. Ton cadre écran aura beaucoup plus de poids." },
    ],
  },
  {
    id: "q14",
    title: "Colères : tu sais te réguler ?",
    description: "5 questions sur TA gestion de TES émotions.",
    category: "Moi parent",
    ages: "Tous âges",
    questions: [
      { q: "Tu sens la colère monter :", options: [
        { text: "Je préviens et je sors respirer", score: 4 },
        { text: "J'explose", score: 1 },
        { text: "Je serre les dents", score: 2 },
      ]},
      { q: "Tes déclencheurs :", options: [
        { text: "Je les connais bien", score: 4 },
        { text: "Je ne les ai jamais identifiés", score: 1 },
        { text: "Vaguement", score: 2 },
      ]},
      { q: "Après avoir crié :", options: [
        { text: "Je répare avec des mots simples", score: 4 },
        { text: "Je me referme", score: 1 },
        { text: "Je compense par un cadeau", score: 2 },
      ]},
      { q: "Quand tu es à bout :", options: [
        { text: "Je passe le relais", score: 4 },
        { text: "Je tiens jusqu'à la rupture", score: 1 },
        { text: "Je m'isole un moment", score: 2 },
      ]},
      { q: "Ta fatigue influence ta patience :", options: [
        { text: "Je l'anticipe et j'allège la journée", score: 4 },
        { text: "Je la subis", score: 1 },
        { text: "Je la remarque après coup", score: 2 },
      ]},
    ],
    feedback: [
      { min: 5, max: 10, title: "Le volcan est proche", text: "Identifie tes deux déclencheurs principaux cette semaine. Anticiper vaut mieux que se maîtriser à chaud." },
      { min: 11, max: 15, title: "Tu apprends à te connaître", text: "Tu te régules de mieux en mieux. Le relais passé à temps évite 80 % des dérapages." },
      { min: 16, max: 20, title: "Belle régulation", text: "Tu montres à ton enfant qu'une émotion forte peut se traverser sans faire de dégâts. C'est une leçon pour la vie." },
    ],
  },
  {
    id: "q15",
    title: "Ton ado et toi : où en êtes-vous ?",
    description: "4 questions sur le lien à l'adolescence.",
    category: "Ados",
    ages: "Dès 11 ans",
    questions: [
      { q: "Quand il s'enferme dans sa chambre :", options: [
        { text: "Je respecte et je reste disponible", score: 4 },
        { text: "Je force la porte", score: 1 },
        { text: "Je me vexe", score: 2 },
      ]},
      { q: "Ses amis :", options: [
        { text: "Je les connais, ils passent à la maison", score: 4 },
        { text: "Je ne sais pas qui ils sont", score: 1 },
        { text: "Je connais les prénoms", score: 2 },
      ]},
      { q: "Quand il conteste une règle :", options: [
        { text: "J'explique le pourquoi et je maintiens", score: 4 },
        { text: "Je dis « c'est comme ça »", score: 1 },
        { text: "Je cède pour éviter le conflit", score: 2 },
      ]},
      { q: "Les sujets sensibles (réseaux, amour, alcool) :", options: [
        { text: "On en parle avant que ça arrive", score: 4 },
        { text: "On n'en parle jamais", score: 1 },
        { text: "Seulement en cas de problème", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Le lien s'est distendu", text: "Ne cherche pas la grande discussion : crée des moments côte à côte (trajet, cuisine). C'est là que les ados parlent." },
      { min: 9, max: 12, title: "Le lien tient", text: "Tu restes présent sans envahir. Anticipe les sujets sensibles : en parler avant, c'est déjà protéger." },
      { min: 13, max: 16, title: "Une relation de confiance", text: "Tu respectes son intimité tout en gardant un cadre. Il reviendra vers toi quand ça comptera." },
    ],
  },
  {
    id: "q16",
    title: "Rivalité ou coopération ?",
    description: "4 questions sur l'ambiance entre tes enfants.",
    category: "Fratrie",
    ages: "Dès 4 ans",
    questions: [
      { q: "Les tâches communes :", options: [
        { text: "Je leur donne un objectif d'équipe", score: 4 },
        { text: "Je lance « le premier qui… »", score: 1 },
        { text: "Chacun sa tâche séparée", score: 2 },
      ]},
      { q: "Quand l'un réussit :", options: [
        { text: "Je félicite sans comparer", score: 4 },
        { text: "Je cite l'exemple à l'autre", score: 1 },
        { text: "Je félicite discrètement", score: 2 },
      ]},
      { q: "Les étiquettes (« le sage », « la tornade ») :", options: [
        { text: "Je les évite", score: 4 },
        { text: "Je les utilise souvent", score: 1 },
        { text: "Ça m'échappe parfois", score: 2 },
      ]},
      { q: "Quand ils jouent bien ensemble :", options: [
        { text: "Je le dis à voix haute", score: 4 },
        { text: "Je ne relève pas", score: 1 },
        { text: "J'en profite pour faire autre chose", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "La rivalité est nourrie", text: "Supprime les courses au « premier qui » et les étiquettes. Remplace-les par un objectif commun : la coopération s'apprend." },
      { min: 9, max: 12, title: "Ça s'équilibre", text: "Tu évites souvent le piège de la comparaison. Nomme leurs bons moments ensemble : ce qui est vu se reproduit." },
      { min: 13, max: 16, title: "Une équipe en formation", text: "Tu cultives la coopération plutôt que la compétition. Leur lien adulte se construit maintenant." },
    ],
  },
  {
    id: "q17",
    title: "Sommeil : les réveils nocturnes",
    description: "4 questions sur les nuits agitées.",
    category: "Sommeil",
    ages: "Dès 6 mois",
    questions: [
      { q: "Quand il se réveille la nuit :", options: [
        { text: "Je le rassure brièvement dans son lit", score: 4 },
        { text: "Je le prends dans le mien systématiquement", score: 2 },
        { text: "Je m'énerve de fatigue", score: 1 },
      ]},
      { q: "La lumière et le bruit la nuit :", options: [
        { text: "Je garde tout très calme et sombre", score: 4 },
        { text: "J'allume, je parle normalement", score: 1 },
        { text: "Petite veilleuse, voix basse", score: 2 },
      ]},
      { q: "Le couchage :", options: [
        { text: "Il s'endort seul dans son lit", score: 4 },
        { text: "Il a besoin de moi jusqu'à l'endormissement", score: 1 },
        { text: "Je reste quelques minutes", score: 2 },
      ]},
      { q: "Les siestes :", options: [
        { text: "Régulières et adaptées à son âge", score: 4 },
        { text: "Supprimées pour qu'il dorme mieux la nuit", score: 1 },
        { text: "Variables", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Des nuits à réparer", text: "La clé, c'est l'endormissement : ce qu'il trouve en s'endormant, il le cherchera à chaque micro-réveil. Avance par toutes petites étapes." },
      { min: 9, max: 12, title: "Ça s'améliore", text: "Tu as les bons réflexes. Garde les nuits ennuyeuses : peu de lumière, peu de mots, retour au lit." },
      { min: 13, max: 16, title: "Nuits en bonne voie", text: "Ton cadre nocturne est cohérent. Les régressions sont normales lors des grands changements : reste constant." },
    ],
  },
  {
    id: "q18",
    title: "Ton enfant ose-t-il se tromper ?",
    description: "4 questions sur le droit à l'erreur.",
    category: "École",
    ages: "Dès 5 ans",
    questions: [
      { q: "Quand il se trompe :", options: [
        { text: "Je dis que c'est comme ça qu'on apprend", score: 4 },
        { text: "Je corrige tout de suite", score: 2 },
        { text: "Je soupire", score: 1 },
      ]},
      { q: "Tes compliments portent sur :", options: [
        { text: "L'effort et la stratégie", score: 4 },
        { text: "Le résultat", score: 2 },
        { text: "Le talent (« tu es doué »)", score: 1 },
      ]},
      { q: "Tu racontes tes propres erreurs :", options: [
        { text: "Oui, régulièrement", score: 4 },
        { text: "Jamais", score: 1 },
        { text: "Rarement", score: 2 },
      ]},
      { q: "Face à un nouveau défi :", options: [
        { text: "Il se lance volontiers", score: 4 },
        { text: "Il refuse par peur de rater", score: 1 },
        { text: "Il hésite longuement", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "La peur de rater est là", text: "Félicite l'effort, pas le talent, et raconte-lui tes propres ratés. L'erreur doit devenir banale à la maison." },
      { min: 9, max: 12, title: "Ça se libère", text: "Tu encourages déjà. Ajoute la phrase magique : « pas encore » à la place de « tu n'y arrives pas »." },
      { min: 13, max: 16, title: "Un enfant qui ose", text: "Tu as créé un terrain sûr pour se tromper. C'est le meilleur prédicteur d'apprentissage durable." },
    ],
  },
  {
    id: "q19",
    title: "Émotions : ton vocabulaire",
    description: "4 questions sur la mise en mots des émotions.",
    category: "Émotions",
    ages: "Dès 2 ans",
    questions: [
      { q: "Quand il pleure sans raison apparente :", options: [
        { text: "Je propose des mots : « déçu ? fatigué ? »", score: 4 },
        { text: "Je dis « arrête de pleurer »", score: 1 },
        { text: "Je le distrais", score: 2 },
      ]},
      { q: "Chez toi, on nomme les émotions :", options: [
        { text: "Tous les jours, même les miennes", score: 4 },
        { text: "Jamais", score: 1 },
        { text: "En cas de gros problème", score: 2 },
      ]},
      { q: "La colère de ton enfant :", options: [
        { text: "Est autorisée, les gestes non", score: 4 },
        { text: "Est interdite", score: 1 },
        { text: "Dépend du contexte", score: 2 },
      ]},
      { q: "Tes propres émotions devant lui :", options: [
        { text: "Je les dis simplement", score: 4 },
        { text: "Je les cache totalement", score: 1 },
        { text: "Elles sortent d'un coup", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Les mots manquent encore", text: "Une émotion nommée est une émotion à moitié apaisée. Commence par nommer les tiennes à voix haute : il copiera." },
      { min: 9, max: 12, title: "Le vocabulaire s'installe", text: "Tu accueilles déjà. Distingue bien l'émotion (toujours ok) du comportement (parfois non) : ça clarifie tout." },
      { min: 13, max: 16, title: "Une maison qui parle vrai", text: "Ton enfant grandit avec des mots pour ce qu'il ressent. C'est un atout immense pour toute sa vie." },
    ],
  },
  {
    id: "q20",
    title: "Le goûter et le sucre",
    description: "4 questions sur les habitudes sucrées.",
    category: "Alimentation",
    ages: "Dès 2 ans",
    questions: [
      { q: "Le goûter type :", options: [
        { text: "Fruit + pain ou laitage", score: 4 },
        { text: "Biscuits industriels tous les jours", score: 1 },
        { text: "Ça dépend du jour", score: 2 },
      ]},
      { q: "Les boissons :", options: [
        { text: "De l'eau presque toujours", score: 4 },
        { text: "Sirop ou soda régulièrement", score: 1 },
        { text: "Jus de fruits quotidiens", score: 2 },
      ]},
      { q: "Le sucre comme récompense :", options: [
        { text: "Jamais", score: 4 },
        { text: "Souvent", score: 1 },
        { text: "Parfois, pour les grandes occasions", score: 2 },
      ]},
      { q: "Le grignotage entre les repas :", options: [
        { text: "Pas de grignotage, quatre vrais repas", score: 4 },
        { text: "Toute la journée", score: 1 },
        { text: "De temps en temps", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Beaucoup de sucre", text: "Commence par les boissons : remplacer les jus et sirops par de l'eau est le changement le plus rapide et le plus efficace." },
      { min: 9, max: 12, title: "Sur la bonne pente", text: "Tu as les bons réflexes par intermittence. Sors le sucre du système de récompense : il perdra son pouvoir." },
      { min: 13, max: 16, title: "Habitudes saines", text: "Ton cadre alimentaire est solide sans être rigide. C'est exactement l'équilibre à viser." },
    ],
  },
  {
    id: "q21",
    title: "Sorties et lieux publics",
    description: "4 questions sur les crises en public.",
    category: "Émotions",
    ages: "Dès 18 mois",
    questions: [
      { q: "Avant d'entrer dans un magasin :", options: [
        { text: "J'annonce le programme et ce qu'on n'achètera pas", score: 4 },
        { text: "Je n'anticipe rien", score: 1 },
        { text: "Je promets une récompense", score: 2 },
      ]},
      { q: "En cas de crise en public :", options: [
        { text: "Je m'occupe de lui, pas du regard des autres", score: 4 },
        { text: "Je cède immédiatement", score: 1 },
        { text: "Je le gronde pour montrer que je gère", score: 2 },
      ]},
      { q: "Les sorties longues :", options: [
        { text: "Je prévois eau, encas et pauses", score: 4 },
        { text: "J'improvise", score: 1 },
        { text: "Je prévois parfois", score: 2 },
      ]},
      { q: "Le moment de la journée choisi :", options: [
        { text: "Hors fatigue et hors faim", score: 4 },
        { text: "N'importe quand", score: 1 },
        { text: "Selon mon emploi du temps seulement", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Les sorties sont risquées", text: "80 % des crises en public sont de la faim, de la fatigue ou de l'imprévu. Annonce le programme avant d'entrer : ça change tout." },
      { min: 9, max: 12, title: "Tu anticipes de mieux en mieux", text: "Continue à préparer le terrain. Et rappelle-toi : le regard des autres n'éduque pas ton enfant." },
      { min: 13, max: 16, title: "Sorties maîtrisées", text: "Tu anticipes et tu restes centré sur ton enfant. C'est exactement la bonne posture." },
    ],
  },
  {
    id: "q22",
    title: "Coparentalité : vous êtes alignés ?",
    description: "4 questions sur votre duo éducatif.",
    category: "Moi parent",
    ages: "Tous âges",
    questions: [
      { q: "Les décisions importantes :", options: [
        { text: "On en parle à deux, avant", score: 4 },
        { text: "Chacun décide dans son coin", score: 1 },
        { text: "On en parle après coup", score: 2 },
      ]},
      { q: "Les désaccords éducatifs :", options: [
        { text: "On les règle sans l'enfant", score: 4 },
        { text: "On se contredit devant lui", score: 1 },
        { text: "On évite le sujet", score: 2 },
      ]},
      { q: "Quand l'un est à bout :", options: [
        { text: "L'autre prend le relais", score: 4 },
        { text: "Chacun tient seul", score: 1 },
        { text: "On râle mutuellement", score: 2 },
      ]},
      { q: "Du temps à deux, sans les enfants :", options: [
        { text: "Régulièrement", score: 4 },
        { text: "Jamais", score: 1 },
        { text: "Très rarement", score: 2 },
      ]},
    ],
    feedback: [
      { min: 4, max: 8, title: "Le duo s'épuise", text: "Prenez 15 minutes par semaine pour parler éducation, hors tension. Les désaccords réglés en privé protègent l'enfant." },
      { min: 9, max: 12, title: "Un duo qui s'ajuste", text: "Vous communiquez. Ajoutez le relais explicite : « je suis à bout, tu prends ? » évite la plupart des dérapages." },
      { min: 13, max: 16, title: "Une équipe solide", text: "Votre cohérence est votre plus grande force éducative. Continuez à préserver votre temps à deux." },
    ],
  },
];
